export const libraries = ["places"];
export const mapOptions = {
    zoom: 12,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false
};

export const types = [
    "book_store",
    "supermarket",
    "grocery_or_supermarket",
    "store",
    "department_store",
    "convenience_store"
].join("|");

export const merchantNames = ["AKO", "Bruna", "The Read Shop", "Primera"];

export const resellerNames = [
    "AKO",
    "The Read Shop",
    "Primera",
    "Jumbo",
    "Hoogvliet",
    "Dirk",
    "Coop",
    "PLUS",
    "DekaMarkt",
    "Spar",
    "Poiesz",
    "Boni",
    "Boon's Markt",
    "Jan Linders"
];
